import { call, put, takeLatest } from 'redux-saga/effects';

import { metricsApi } from '../../api';

import * as actions from './actions';

function* getEndpoints() {
  try {
    yield put({ type: actions.GET_ENDPOINTS_PENDING });

    const data = yield call(metricsApi.getMetricsEndpoints);

    yield put({ type: actions.GET_ENDPOINTS_FULFILLED, payload: data });
  } catch (e) {
    yield put({ type: actions.GET_ENDPOINTS_REJECTED, payload: e });
  }
}

export function* watchGetEndpoints() {
  yield takeLatest(actions.GET_ENDPOINTS, getEndpoints);
}
